// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__Hlqt0","title":"BackImages_title__1-twf","images":"BackImages_images__3vc5J"};